import { Instance } from 'mobx-state-tree';
import { CustomerOrderDtoModelBase } from './CustomerOrderDtoModel.base';
import { CustomerOrderStatus } from './CustomerOrderStatusEnum';

/* The TypeScript type of an instance of CustomerOrderDtoModel */
export interface CustomerOrderDtoModelType extends Instance<typeof CustomerOrderDtoModel.Type> {}

/* A graphql query fragment builders for CustomerOrderDtoModel */
export { selectFromCustomerOrderDto, customerOrderDtoModelPrimitives, CustomerOrderDtoModelSelector } from './CustomerOrderDtoModel.base';

/**
 * CustomerOrderDtoModel
 */
export const CustomerOrderDtoModel = CustomerOrderDtoModelBase
  .volatile(() => ({ isDeleted: false }))
  .actions(self => ({
    markDeleted() { self.isDeleted = true; },
    updateDetails(order: { customerOrderNumber?: string | null; deliveryDate?: string | null }) {
      self.customerOrderNumber = order.customerOrderNumber ?? null;
      if (self.status === CustomerOrderStatus.NOT_SCHEDULED) self.date = order.deliveryDate ?? null;
    },
  }));
